import {
  Avatar,
  Button,
  Card,
  Dropdown,
  Layout,
  Progress,
  Select,
  Steps,
  Table,
  Tabs,
} from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

// Survey Card styled components - following Campaign/Interview Agent pattern
export const SurveyCard = styled(Card)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid #e2e8ee;
  background: ${({ theme }) => theme.settings.whiteColor};
  box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0px 4px 12px rgba(50, 50, 50, 0.1);
  }

  .ant-card-body {
    padding: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &.ant-card-loading {
    .ant-card-body {
      padding: 20px 24px;
    }
  }
`;

export const SurveyCardInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 24px;
  flex: 1;

  & > *:last-child {
    margin-top: auto;
  }
`;

export const SurveyCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.textColor};
    font-family: ${({ theme }) => theme.fonts.inter};
  }
`;

export const SurveyCardResponseCount = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.settings.secondary};

  .count {
    font-weight: 600;
  }

  .label {
    font-weight: 500;
  }
`;

export const SurveyCardTitle = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SurveyCardDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SurveyCardDetailRow = styled.div`
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.settings.primary};
  min-width: 0;

  .label {
    font-weight: 400;
    flex-shrink: 0;
  }

  .value {
    font-weight: 500;
    margin-left: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SurveyCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SurveyCardDate = styled.div`
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.settings.textColor};
  img,
  .anticon {
    width: 14px;
    height: 14px;
    font-size: 14px;
    margin-right: 6px;
    flex-shrink: 0;
  }
`;

export const SurveyCardMenuIcon = styled.span`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0px;
  border-radius: 4px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  img {
    width: 14px;
    height: 16px;
  }
`;

export const SurveyTableActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const SurveyNameLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.settings.primary} !important;
`;

export const OrSelect = styled.div`
  color: ${({ theme }) => theme.settings.textColor} !important;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  font-weight: 400;
  transition: color 0.2s ease;
`;
export const ThemeFullTabs = styled(Tabs)`
  width: 100%;
  position: relative;
  padding: 15px;
  height: 100%;
  .ant-tabs-nav {
    margin-bottom: 24px !important;
    &::before {
      display: none;
    }
  }
  .ant-tabs-extra-content {
    @media only screen and (max-width: 768px) {
      width: 30%;
    }
    .leftWrapper {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.settings.primary};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: block;
      width: 100%;
      @media only screen and (max-width: 991.99px) {
        max-width: 80%;
      }
    }
    .rightWrapper {
      text-align: right;
      font-size: 14px;
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      color: ${({ theme }) => theme.settings.primary};
      font-weight: 500;
      svg {
        color: ${({ theme }) => theme.settings.greenColor};
        font-size: 14px;
      }
      @media only screen and (max-width: 768px) {
        .draftSaved {
          display: none;
        }
      }
    }
  }
  .ant-tabs-nav-list {
    .ant-tabs-tab {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: ${({ theme }) => theme.settings.primary};
      opacity: 0.5;
      margin-left: 40px;
      &:first-child {
        margin-left: 0px;
      }
      @media only screen and (max-width: 768px) {
        margin-left: 15px;
        font-size: 12px;
        line-height: 14px;
      }
      &.ant-tabs-tab-active,
      &:active {
        opacity: 1;
        .ant-tabs-tab-btn {
          color: ${({ theme }) => theme.settings.mainColor};
        }
      }
    }
  }
  .ant-tabs-ink-bar {
    min-width: 60px;
    border-radius: 50%;
    background: ${({ theme }) => theme.settings.mainColor} !important;
  }
`;
export const ThemeFitToScreenCard = styled(Card)`
  width: 100%;
  position: relative;
  height: 100%;
  background: transparent;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
  box-shadow: none !important;
  .ant-card-body {
    padding: 0px;
    background: transparent;
  }
  /* Proper padding for skeleton loading state */
  &.ant-card-loading .ant-card-body {
    padding: 24px;
  }
  &.hasHeader {
    .ant-card-head {
      padding: 0px 15px;
      background: ${({ theme }) => theme.settings.whiteColor};
      font-size: 14px;
      font-weight: 600;
      min-height: 46px;
      color: ${({ theme }) => theme.settings.primary};
      margin-bottom: 1px !important;
    }
  }
  .ant-card-actions {
    display: block;
    border-top: none !important;
    padding: 5px 15px 15px 15px;
    background: transparent !important;
    li {
      width: 100%;
      margin: 0px !important;
      list-style: none;
    }
  }
  .scrollable {
    height: calc(100vh - 200px);
    padding: 15px 15px 0px 15px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 1px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.primary};
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    &.fullHeight {
      height: calc(100vh - 130px);
    }
  }

  &.chatWrapper {
    height: calc(100vh - 90px);
    background: ${({ theme }) => theme.settings.whiteColor};
    border-radius: 16px;
    border: none;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    @media only screen and (max-width: 991.99px) {
      height: calc(100vh - 80px) !important;
    }
    .ant-card-head {
      border-bottom: 1px solid #edeef3;
      min-height: 64px;
      height: 64px;
      display: flex;
      align-items: center;
      background: transparent;
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      padding: 0 28px;
      .ant-card-head-title {
        font-size: 14px;
        font-weight: 600;
        color: ${({ theme }) => theme.settings.primary};
        font-family: ${({ theme }) => theme.fonts.montserrat};
      }
    }
    .ant-card-body {
      height: calc(100% - 64px);
      display: flex;
      flex-direction: column;
      padding: 0px;
      background: ${({ theme }) => theme.settings.whiteColor};
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
    }
    /* Proper padding for skeleton loading state */
    &.ant-card-loading .ant-card-body {
      padding: 24px;
    }
    .scrollable {
      flex: 1;
      height: auto;
      overflow-y: auto;
      padding: 28px 28px 16px 28px;
      min-height: 0;
      background: ${({ theme }) => theme.settings.whiteColor};
    }
  }
  /* .cardScrollable {
    width: 100%;
    position: relative;
    height: calc(100vh - 170px);
    overflow-y: auto !important;
    padding: 0px 20px;
    @media only screen and (max-width: 991.99px) {
      height: 100% !important;
    }
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.mainColor};
      border-radius: 3px;
      &:hover {
        background: ${({ theme }) => theme.settings.mainColor};
        opacity: 0.8;
      }
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    }
  } */
  /* &.coverWrapper {
    height: calc(100vh - 100px);
  }
  &.previewWrapper {
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.06);
    border-radius: 20px !important;
    .ant-card-head {
      padding: 10px 50px !important;
      @media only screen and (max-width: 991.99px) {
        padding: 8px 16px !important;
      }
    }
    .ant-card-body {
      height: calc(100vh - 240px) !important;
      overflow-y: auto !important;
      padding: 10px 50px !important;
      @media only screen and (max-width: 991.99px) {
        height: 100% !important;
        padding: 8px 16px !important;
      }
      .wrapper {
        width: 100%;
        position: relative;
        margin-bottom: 30px;
      }
      &::-webkit-scrollbar {
        width: 2px;
        height: 2px;
      }
      &::-webkit-scrollbar-track {
        background: ${({ theme }) => theme.settings.borderColor};
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.settings.mainColor};
        border-radius: 3px;
        &:hover {
          background: ${({ theme }) => theme.settings.mainColor};
          opacity: 0.8;
        }
      }
      &::-webkit-scrollbar-corner {
        background: ${({ theme }) => theme.settings.borderColor};
      }
    }
  }
  &.previewCenterAlign {
    margin-top: 40px !important;
    @media only screen and (max-width: 991.99px) {
      margin-top: 0px !important;
    }
    .ant-card-body {
      height: 100% !important;
      min-height: 400px !important;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: start;
    }
  }
  &.conversationalWrapper {
    .ant-card-body {
      height: calc(100vh - 120px) !important;
      overflow-y: auto !important;
      padding: 0px !important;
      margin: 0px !important;
      @media only screen and (max-width: 768.99px) {
        height: 100% !important;
      }
    }
  } */
`;
export const ThemeChatMassage = styled.div`
  width: 100%;
  position: relative;
  padding: 20px;
  /* max-height: calc(100vh - 310px); */
  max-height: calc(100vh - 270px);
  overflow-y: auto !important;
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.settings.borderColor};
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.settings.mainColor};
    border-radius: 3px;
    &:hover {
      background: ${({ theme }) => theme.settings.mainColor};
      opacity: 0.8;
    }
  }
  &::-webkit-scrollbar-corner {
    background: ${({ theme }) => theme.settings.borderColor};
  }
  .messageContainer {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 15px;
    width: 100%;
  }

  .avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${({ theme }) => theme.settings.borderColor};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &.assistant {
      padding: 5px;
      background: ${({ theme }) => theme.settings.whiteColor};
      border: 1px solid ${({ theme }) => theme.settings.borderColor};
      img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }
  }

  .messageContent {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .messageHeader {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 5px;
    margin-bottom: 4px;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    color: ${({ theme }) => theme.settings.primary};
  }
  .senderName {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.primary};
  }
  .timestamp {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 12px;
    color: ${({ theme }) => theme.settings.textColor};
  }
  .messageText {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.primary};
    word-wrap: break-word;
  }
  .typingIndicator {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 15px;
    .dot {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: ${({ theme }) => theme.settings.primary};
      animation: typing 1.4s infinite ease-in-out;

      &:nth-child(1) {
        animation-delay: -0.32s;
      }
      &:nth-child(2) {
        animation-delay: -0.16s;
      }
      &:nth-child(3) {
        animation-delay: 0s;
      }
      &:nth-child(4) {
        animation-delay: 0.16s;
      }
    }
  }

  @keyframes typing {
    0%,
    80%,
    100% {
      transform: scale(0.8);
      opacity: 0.5;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }
  .clientMessage {
    width: 100%;
    position: relative;
  }

  .assistantMessage {
    width: 100%;
    position: relative;
  }
`;
export const ThemeStudyCover = styled.div`
  width: 100%;
  position: relative;
  padding: 20px;
  max-height: calc(100vh - 170px);
  overflow-y: auto !important;
  @media only screen and (max-width: 991.99px) {
    max-height: 100% !important;
  }
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.settings.borderColor};
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.settings.mainColor};
    border-radius: 3px;
    &:hover {
      background: ${({ theme }) => theme.settings.mainColor};
      opacity: 0.8;
    }
  }
  &::-webkit-scrollbar-corner {
    background: ${({ theme }) => theme.settings.borderColor};
  }
`;
export const ThemeCoverBox = styled(Card)`
  width: 100%;
  position: relative;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 10px;
  background: ${({ theme }) => theme.settings.whiteColor};
  .ant-card-body {
    padding: 15px;
  }
  .defaultCardText {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    font-family: ${({ theme }) => theme.fonts.inter};
    color: ${({ theme }) => theme.settings.primary};
    img {
      width: 28px;
      float: left;
      margin: 5px 10px 0px 0px;
      object-fit: contain;
    }
  }
  .ant-card-head {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.primary};
    min-height: 40px !important;
    padding: 0px 10px !important;
    border: none !important;
    button {
      text-align: center;
      float: right;
      transition: all 0.2s ease;
      transform: translateY(400px);
      opacity: 0;
      img {
        margin: 0 auto;
      }
    }
  }

  &.background,
  &:hover {
    background: ${({ theme }) => theme.settings.bodyBg};
    button {
      display: block;
      transform: translateY(0) !important;
      opacity: 1;
    }
  }
`;
export const ThemeStepsWrapper = styled(Card)`
  width: 100%;
  position: relative;
  background: transparent;
  border: none !important;
  .ant-card-head {
    border: none !important;
    @media only screen and (max-width: 991.99px) {
      padding: 0px !important;
    }
  }
  .ant-card-body {
    height: calc(100vh - 180px);
    padding: 0px 30px !important;
    overflow-y: auto;
    .minHeight {
      min-height: 450px;
      @media only screen and (max-width: 991.99px) {
        min-height: 100%;
      }
    }
    @media only screen and (max-width: 991.99px) {
      height: 100% !important;
      padding: 0px 0px !important;
      overflow-x: hidden !important;
    }
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.mainColor};
      border-radius: 3px;
      &:hover {
        background: ${({ theme }) => theme.settings.mainColor};
        opacity: 0.8;
      }
    }
    &::-webkit-scrollbar-corner {
      background: ${({ theme }) => theme.settings.borderColor};
    }
  }
`;
export const StepCounter = styled.span`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.textColor};
`;
export const ProgressSection = styled.div`
  width: 100%;
  margin: 0 auto 20px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ProgressInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const ProgressLabel = styled.span`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.primary};
`;
export const ThemeProgress = styled(Progress)`
  min-width: 100%;
  .ant-progress-bg {
    background: ${({ theme }) => theme.settings.mainColor} !important;
  }
  .ant-progress-outer {
    background: ${({ theme }) => theme.settings.borderColor} !important;
  }
`;
export const ThemePreviewTabs = styled(Tabs)`
  width: 100%;
  position: relative;
  padding: 15px;
  height: 100%;
  .ant-tabs-nav {
    padding-bottom: 10px !important;
  }
  .ant-tabs-extra-content {
    @media only screen and (max-width: 768px) {
      width: 30%;
    }
    .leftWrapper {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.settings.primary};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: block;
      width: 100%;
      @media only screen and (max-width: 991.99px) {
        max-width: 80%;
      }
    }
    .rightWrapper {
      text-align: right;
      font-size: 14px;
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      color: ${({ theme }) => theme.settings.primary};
      font-weight: 500;
      svg {
        color: ${({ theme }) => theme.settings.greenColor};
        font-size: 14px;
      }
      @media only screen and (max-width: 768px) {
        .draftSaved {
          display: none;
        }
      }
    }
  }
  .ant-tabs-nav-list {
    background: rgba(240, 240, 240, 1) !important;
    border-radius: 12px;
    padding: 10px;
    .ant-tabs-tab {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: ${({ theme }) => theme.settings.primary};
      margin-left: 10px;
      padding: 7px;
      border-radius: 8px;
      @media only screen and (max-width: 768px) {
        padding: 5px;
      }
      &:first-child {
        margin-left: 0px;
      }
      svg,
      img {
        color: ${({ theme }) => theme.settings.primary};
        filter: ${({ theme }) => theme.settings.imgFilterColor};
      }
      @media only screen and (max-width: 768px) {
        margin-left: 15px;
        font-size: 12px;
        line-height: 14px;
      }
      &.ant-tabs-tab-active,
      &:active {
        background: ${({ theme }) => theme.settings.mainColor};
        svg,
        img {
          color: ${({ theme }) => theme.settings.whiteColor};
          filter: ${({ theme }) => theme.settings.imgFilterWhite};
        }
        .ant-tabs-tab-btn {
          color: ${({ theme }) => theme.settings.mainColor};
        }
      }
    }
  }
  .ant-tabs-ink-bar {
    display: none;
  }
`;
// new style
export const ThemeNoSidebar = styled.div`
  width: 100%;
  position: relative;
  padding: 20px 20px 0px 20px;
  min-height: 100vh;
  @media only screen and (max-width: 991.99px) {
    .survey-study-header {
      gap: 12px;
      min-width: 0;
    }

    .survey-study-title-group {
      flex: 1 1 auto;
      min-width: 0;
      max-width: 100%;
      overflow: visible !important;
    }

    .survey-study-title-group > .ant-space-item:first-child {
      flex: 0 0 auto;
    }

    .survey-study-title-group > .ant-space-item:last-child {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
    }

    .survey-study-copy-button {
      flex: 0 0 auto;
      max-width: 55%;
      min-height: 32px;
      padding-inline: 10px;
      white-space: nowrap;
      line-height: 16px;
      font-size: 12px !important;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;

      .ant-btn-icon,
      > .anticon {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        flex: 0 0 14px;
        width: 14px;
        height: 14px;
        margin-inline-end: 0 !important;
        line-height: 1;
      }

      > span:not(.ant-btn-icon) {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        line-height: 16px;
        text-align: center;
      }
    }
  }
  .leftWrapper {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.settings.primary};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    width: 100%;
    @media only screen and (max-width: 991.99px) {
      max-width: 80%;
    }
  }
  .rightWrapper {
    text-align: right;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    color: ${({ theme }) => theme.settings.primary};
    font-weight: 500;
    svg {
      color: green;
      font-size: 14px;
    }
  }
`;
